(function ($,_) {
  _.UI.extend('Daguan', {
    init: function (box, options) {
      this.base(box, options);
      this.opt = $.extend({}, _.Daguan.defaultOptions, this.opt);
      this.currentPage = 1;
      this.listFlow = this.box.find('.list-flow');
      this.infoTip = this.box.find('.info-flow');
      this.bindEvent();
    },
    bindEvent:function(){
      $(window).bind('scroll',this.onScroll.bind(this));
    },
    scrollTimer:null,
    onScroll :function(e){
  		var me = this;
      clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(function(){
        if($(window).scrollTop()+$(window).height()>= ($(document).height() - 30)){
          me.loadMore();
        }
      },300);
    },
    //显示加载中
    loading:function(){
      this.infoTip.text('').addClass('loading').show();
      this.isLoading = true;
    },
    //隐藏加载中
    loaded:function(){
      this.infoTip.removeClass('loading');//.hide();
      this.isLoading = false;
    },
    getData:function(href,fn){
      $.get(href, { r: ue.getTimeStamp(360000) }, function (txt) {
        fn(txt);
      });
    },
    loadMore:function(){
      var me = this,href;
      if(this.isLoading)return;
      if(this.currentPage >= this.opt.totalPage){
        $(window).unbind('scroll',this.onScroll);
        me.infoTip.text('貌似没有更多了  &.<').show();
        return;
      }
      me.loading();
      this.currentPage++;
      href = this.opt.urlTemplate.replace('{index}',this.currentPage);
      me.getData(href,function(items){
        me.render($(items));
        //setTimeout(function(){
        me.loaded();
        //},2000);
      });
    },
    //0为左边,1右边
    currentSide:0,
    render:function(items){
      var me = this;
      items.filter('.item').each(function(i,n){
        var currentList = me.listFlow.eq(me.currentSide % 2);
      	currentList.append(n);
        $(document.body).trigger('appendHtml', currentList);
        me.currentSide++;
      });
    }
  });

  _.Daguan.defaultOptions = {
    totalPage:4
  };
})(jQuery,ue);